<h1 class="header" mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <mat-label>{{'general.presetTransitions' | transloco}}</mat-label>
  <div class="dlg-drag-handle" cdkDragHandle>
    <svg width="24px" fill="currentColor" viewBox="0 0 24 24">
      <path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
      <path d="M0 0h24v24H0z" fill="none"></path>
    </svg>
  </div>
</h1>
<div mat-dialog-content>
  <mat-grid-list cols="2" rowHeight="2:1">
    @for (item of presets; track item) {
      <mat-grid-tile>
        <img (click)="onPresetSelected(item)" class="mouseOver" style="height: 120px" src="assets/transitions/{{item.transition_item_name}}.gif">
      </mat-grid-tile>
    }
  </mat-grid-list>
</div>
